import {getIsUserGlobalAdmin} from '../../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {createSelector} from '../../../../srcCommon/helpers/reselectHelpers';
import {getIsInTrialOrExpired} from '../../../store/data/company/companySelectors';

/*
 * Selectors.
 */

export const getIsTrialBottomBarVisible = createSelector(
  [getIsUserGlobalAdmin, getIsInTrialOrExpired],
  (isGlobalAdmin, isInTrialOrExpired) => isGlobalAdmin && isInTrialOrExpired,
);
